import {
  collection,
  getDocs,
  query,
  QueryConstraint,
  where,
} from "firebase/firestore";
import { db } from "../../config/firebase-config";
import useColection from "../colection";
import { useContext } from "react";
import { UserContext } from "../../context";

const useInvoiceConfig = () => {
  const others = useColection<{ nextId: number }>("invoice");

  return { ...others };
};

export default useInvoiceConfig;
